import React from 'react';
import { IconProps } from '.';

const SvgBoxMystore = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#FA7840'
        d='M18.667 2H5.333A3.333 3.333 0 0 0 2 5.333v13.334A3.333 3.333 0 0 0 5.333 22h13.334A3.333 3.333 0 0 0 22 18.667V5.333A3.333 3.333 0 0 0 18.667 2Z'
      />
      <path
        fill='#fff'
        d='M19.902 8.084h-1.443a.117.117 0 0 0-.111.077l-.245.716c-.452 1.277-.923 2.619-1.745 2.619a.366.366 0 0 1-.153-.03.305.305 0 0 1-.064-.04.404.404 0 0 1-.136-.271 1.34 1.34 0 0 1 .008-.358c.02-.149.052-.296.09-.442.043-.166.094-.33.149-.492.057-.17.119-.339.183-.506a20.388 20.388 0 0 1 .374-.91l.054-.126.044-.102c.027-.064-.023-.135-.096-.135h-1.447a.118.118 0 0 0-.11.071l-.032.08c-.217.512-.272.646-.598 1.53-.22.596-.448 1.043-.84 1.552-.35.454-.77.784-1.2.879a.495.495 0 0 1-.144.012c-.22-.017-.36-.185-.313-.388.067-.285.288-.6.472-.92.32-.609.645-1.157.628-1.727 0-.68-.519-1.173-1.233-1.173-.6 0-1.371.295-1.978 1.208-.033.05-.115.019-.103-.04.068-.319.108-.578-.018-.812-.203-.38-.745-.362-.89-.347-.326.032-.713.141-1.215.57-.123.105-.305.32-.512.577l-.001.001-.016.019a.25.25 0 0 1-.051.047.106.106 0 0 1-.02.007.065.065 0 0 1-.07-.023l-.003-.003c-.02-.046.03-.095.029-.095.298-.354.468-.805.494-.97.005-.03-.017-.053-.048-.053H6.005a.097.097 0 0 0-.093.063l-1.907 5.377c-.021.06.026.123.093.123H5.51a.117.117 0 0 0 .113-.08l.079-.241c.863-2.686 1.576-3.751 2.35-3.796.078-.004.17.02.215.084.051.072.056.166.054.25a1.93 1.93 0 0 1-.048.358c-.046.19-.11.407-.182.63l-.953 2.609-.023.062c-.023.06.024.124.092.124h1.4a.117.117 0 0 0 .112-.079l.026-.078c.379-1.106 1.343-3.962 2.467-3.962.067 0 .243 0 .243.272 0 .246-.198.575-.412.97-.268.493-.543.95-.585 1.47-.07.858.515 1.407 1.383 1.458.655.04 1.6-.378 2.295-1.136.096-.105.216-.264.318-.394a.048.048 0 0 1 .079.007c.026.05.054.096.086.141.238.337.643.508 1.204.508.35 0 .717-.115 1.02-.313.038-.025.087.01.072.051l-.163.444a.048.048 0 0 1-.04.03c-1.072.108-2.054.373-2.768.748-.898.472-1.353 1.086-1.353 1.827 0 .958.931 1.396 1.853 1.387 1.555-.015 2.825-1.126 3.494-3.044.33-.948.659-1.837.965-2.7l1.09-3.049c.022-.06-.025-.123-.092-.123Zm-3.621 6.22c-.477.912-1.095 1.432-1.71 1.432-.188 0-.412-.054-.412-.311 0-.213.22-.471.589-.692.39-.234.913-.408 1.483-.494.038-.005.066.032.05.064Z'
      />
    </svg>
  );
};

export default SvgBoxMystore;
